import type { NloError } from '#imports';
import { getKlError } from '~/api/error-helpers';

export function klErrorParser(error: Error): NloError {
	if (error instanceof NloApiError) {
		throw getKlError(error);
	} else {
		// Something occurred in the network connection with the api.
		throw new NloNetworkError(error);
	}
}
